"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationManufacturerDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
const ManufacturerDto_1 = require("../manufacturers/ManufacturerDto");
class LocationManufacturerDto {
    constructor(params) {
        if (!params) {
            return;
        }
        this.locationId = params.locationId;
        this.manufacturerId = params.manufacturerId;
        if (params.location !== undefined) {
            this.location = params.location === null ?
                null :
                new LocationDto_1.LocationDto(params.location);
        }
        if (params.manufacturer !== undefined) {
            this.manufacturer = params.manufacturer === null ?
                null :
                new ManufacturerDto_1.ManufacturerDto(params.manufacturer);
        }
    }
}
exports.LocationManufacturerDto = LocationManufacturerDto;
//# sourceMappingURL=LocationManufacturerDto.js.map